<template>
  <div class="subscription" v-if="loaded">
    <div class="centered-column">
      <div class="container-header">
        <h3>{{ label.get("subscription") }}</h3>
      </div>
      <div class="content-section">
        <!-- Current plan -->
        <div class="white-card">
          <div class="white-card-header">
            <div class="title-wrap">
              <label class="title-label">{{
                label.get("subscription_our_active_plan")
              }}</label>
            </div>
          </div>
          <div v-if="!cancelled" class="current-plan">
            <div class="plan">
              <h3 class="plan-title">
                {{ label.get(subscription.stripe_price + "_plan") }}
              </h3>
              <p
                v-if="!changedPlan"
                v-html="
                  label.get('active_subscription_description', {
                    stripe_price: label.get(subscription.stripe_price),
                    nextPayment: nextPayment,
                    nextChargeAmount: nextChargeAmount,
                  })
                "
              />
              <p
                v-if="changedPlan"
                v-html="
                  label.get(
                    'your_subscription_will_switch_to_annual_or_month_description',
                    {
                      changedPlan_plan: label.get(changedPlan.plan),
                      nextPayment: nextPayment,
                      changePlanAmount: changePlanAmount,
                    }
                  )
                "
              />
            </div>
            <div class="pricing">
              <h3>${{ planPricePerMonth }}</h3>
              <span>{{ label.get("user_month") }}</span>
            </div>
          </div>

          <!-- reactivate subscription -->
          <div v-if="cancelled" class="cancelled">
            <div>
              <h3
                v-html="
                  label.get('your_subscription_has_been_cancelled', {
                    stripe_price: label.get(subscription.stripe_price),
                  })
                "
              />
              <p
                class="cancelled"
                v-html="
                  label.get(
                    'your_current_active_subscription_plan_is_valid_until',
                    { nextPayment: nextPayment }
                  )
                "
              />
            </div>
            <div class="btn-wrap">
              <button
                class="atto-btn submit switch md-btn"
                @click="reactivateSubscription"
              >
                {{ label.get("reactivate_subscription") }}
              </button>
            </div>
          </div>
        </div>
        <!-- Switch plan -->
        <div class="white-card">
          <div class="white-card-header">
            <div class="title-wrap">
              <label class="title-label">{{
                label.get("change_active_plan")
              }}</label>
            </div>
          </div>
          <div class="switch-plan">
            <p
              v-if="
                !changedPlan &&
                  (subscription.stripe_price === 'monthly' ||
                    subscription.stripe_price === 'monthly_7'||
                    subscription.stripe_price === 'monthly_9')
              "
              v-html="label.get('switch_your_plan_to_annual_description')"
            />
            <p
              v-if="
                !changedPlan &&
                  (subscription.stripe_price === 'annual' ||
                    subscription.stripe_price === 'annual_60'||
                    subscription.stripe_price === 'annual_95')
              "
              v-html="label.get('switch_your_plan_to_monthly_description')"
            />
            <!--            <p
                v-if="!changedPlan"
                v-html="label.get('active_subscription_description', {
              stripe_price: label.get(subscription.stripe_price),
              nextPayment: nextPayment,
              nextChargeAmount: nextChargeAmount})"
            />-->
            <p
              v-if="changedPlan"
              v-html="
                label.get(
                  'your_subscription_will_switch_to_annual_or_month_description',
                  {
                    changedPlan_plan: label.get(changedPlan.plan),
                    nextPayment: nextPayment,
                    changePlanAmount: changePlanAmount,
                  }
                )
              "
            />
            <div class="btn-wrap">
              <button
                v-if="!changedPlan"
                class="atto-btn submit switch md-btn"
                @click="switchSubscriptionPlan"
              >
                {{
                  label.get("switch_to_annual_monthly", {
                    changePlan: label.get(changePlan),
                  })
                }}
              </button>
              <button
                v-if="changedPlan"
                class="atto-btn submit switch md-btn"
                @click="cancelSwitchSubscriptionPlan"
              >
                {{ label.get("subscription_cancel_plan_change") }}
              </button>
              <!--              <span
                  v-if="(subscription.stripe_price === 'monthly' || subscription.stripe_price === 'monthly_7' || subscription.stripe_price === 'monthly_business') && !changedPlan"
                  class="save-label"
              >{{ label.get('save') }} 20%</span>-->
            </div>
          </div>
        </div>
        <!-- Manage seats -->
        <div class="white-card">
          <div class="white-card-header">
            <div class="title-wrap">
              <label class="title-label">
                {{ label.get("subscription_manage_seats") }}</label
              >
            </div>
          </div>
          <div class="manage-seats">
            <div class="manage">
              <p
                v-html="
                  label.get('subscription_manage_seats_description', {
                    activeUsers: activeUsers,
                    quantity: quantity,
                  })
                "
              />
            </div>
            <div class="btn-wrap">
              <button
                class="atto-btn submit switch md-btn"
                @click="purchaseSeats"
              >
                {{ label.get("subscription_purchase_seats") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <purchase-seats-component
      v-if="showPurchaseSeats"
      :prorated-cost-per-user="proratedCostPerUser"
      :prorated-tax-per-user="proratedTaxPerUser"
      :is-first-purchase-stripe-tax="isFirstPurchaseStripeTax"
      :quantity="quantity"
      :active-users="activeUsers"
      :invites="invites"
    />
    <purchase-seats-successful-component
      v-if="showPurchaseSeatsSuccess"
      :seats="purchasedSeats"
      :show-invite-button="showInviteButton"
    />

    <switch-subscription-plan-component
      v-if="showSwitchSubscriptionPlan"
      :change-plan="changePlan"
      :next-payment="nextPayment"
      :active-users="activeUsers"
      :change-plan-price="changePlanPrice"
      :total-amount="changePlanAmount"
    />

    <cancel-switch-subscription-plan-component
      v-if="showCancelSwitchSubscriptionPlan"
      :from-plan="subscription.stripe_price"
      :to-plan="changePlan"
    />

    <reactivate-subscription-component v-if="showReactivateSubscription" />
  </div>
</template>

<script>
import PurchaseSeatsComponent from "./PurchaseSeatsComponent";
import PurchaseSeatsSuccessfulComponent from "./PurchaseSeatsSuccessfulComponent";
import SwitchSubscriptionPlanComponent from "./SwitchSubscriptionPlanComponent";
import CancelSwitchSubscriptionPlanComponent from "./CancelSwitchSubscriptionPlanComponent";
import ReactivateSubscriptionComponent from "./ReactivateSubscriptionComponent";
import BillingService from "../services/BillingService";

export default {
  name: "BillingSubscriptionComponent",
  components: {
    PurchaseSeatsComponent,
    PurchaseSeatsSuccessfulComponent,
    SwitchSubscriptionPlanComponent,
    CancelSwitchSubscriptionPlanComponent,
    ReactivateSubscriptionComponent,
  },
  data() {
    return {
      cancelled: false,
      loaded: false,
      onTrial: false,
      trialEndsAt: null,
      onGracePeriod: false,
      activeUsers: 0,
      changePlan: null,
      changedPlan: null,
      nextPayment: null,
      planPrice: 7,
      planPricePerMonth: 7,
      changePlanPrice: 7,
      seatsAvailable: 0,
      subscription: {},
      nextChargeAmount: 0,
      changePlanAmount: 0,
      proratedCostPerUser: 0,
      proratedTaxPerUser: 0,
      isFirstPurchaseStripeTax: false,
      quantity: 0,
      purchasedSeats: 0,
      invites: [],
      showPurchaseSeats: false,
      showCancelSubscription: false,
      showSwitchSubscriptionPlan: false,
      showCancelSwitchSubscriptionPlan: false,
      showReactivateSubscription: false,
      showDefaultPaymentMethod: false,
      showPurchaseSeatsSuccess: false,
      showInviteButton: true,
    };
  },
  created() {
    this.getSubscription();
  },
  mounted() {
    this.$root.$on("hidePurchaseSeats", this.hidePurchaseSeats);
    this.$root.$on("hideCancelSubscription", this.hideCancelSubscription);
    this.$root.$on(
      "hideSwitchSubscriptionPlan",
      this.hideSwitchSubscriptionPlan
    );
    this.$root.$on(
      "hideCancelSwitchSubscriptionPlan",
      this.hideCancelSwitchSubscriptionPlan
    );
    this.$root.$on(
      "hideReactivateSubscription",
      this.hideReactivateSubscription
    );
    this.$root.$on(
      "hidePurchaseSeatsSuccessful",
      this.hidePurchaseSeatsSuccessful
    );

    const purchaseSeatsParam = this.$route.query.p;
    if (purchaseSeatsParam !== undefined) {
      this.purchaseSeats();
    }
  },
  methods: {
    getSubscription() {
      BillingService.getSubscription()
        .then((result) => {
          this.onTrial = result.onTrial;
          this.trialEndsAt = result.trialEndsAt;
          this.onGracePeriod = result.onGracePeriod;
          this.activeUsers = result.activeUsers;
          this.changedPlan = result.changedPlan;
          this.nextPayment = result.nextPayment;
          this.planPrice = result.planPrice;
          this.planPricePerMonth = result.planPricePerMonth;
          this.changePlanPrice = result.changePlanPrice;
          this.seatsAvailable = result.seatsAvailable;
          this.quantity = result.quantity;
          this.subscription = result.subscription;
          this.nextChargeAmount = result.nextChargeAmount;
          this.changePlanAmount = result.changePlanAmount;
          this.changePlan = result.changePlan;
          this.cancelled = this.onGracePeriod && this.changedPlan === null;
          this.$emit("onSubscriptionLoad", {
            nextPayment: this.nextPayment,
            cancelled: this.cancelled,
          });
          this.loaded = true;
        })
        .catch((error) => {
          if (error.response.status === 403) {
            this.$router.push({ path: "/subscription/plans" });
          }
        });
    },

    manageSeats: function() {
      this.$root.$emit("manageTeamMembers");
    },

    purchaseSeats: function() {
      this.$store.commit("showLoading");
      BillingService.getProratedCost()
        .then((result) => {
          this.proratedCostPerUser = result.proratedCostPerUser;
          this.proratedTaxPerUser = result.proratedTaxPerUser;
          this.isFirstPurchaseStripeTax = result.isFirstPurchaseStripeTax;
          this.quantity = result.quantity;
          this.activeUsers = result.activeUsers;
          this.invites = result.invites.map((item, idx) => {
            item.index = idx;
            item.deleting = false;
            item.confirm_delete = false;
            return item;
          });
          this.$store.commit("hideLoading");
          this.showPurchaseSeats = true;
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
        });
    },

    hidePurchaseSeats(data) {
      this.showPurchaseSeats = false;
      if (data) {
        const _this = this;
        this.quantity += parseInt(data.seats);
        setTimeout(() => {
          _this.purchasedSeats = data.seats;
          _this.showInviteButton = data.showInviteButton;
          _this.showPurchaseSeatsSuccess = true;
        }, 300);
      }
    },

    cancelSubscription() {
      this.showCancelSubscription = true;
    },

    hideCancelSubscription(cancel) {
      this.showCancelSubscription = false;
      if (cancel) {
        this.cancelled = true;
      }
    },

    reactivateSubscription() {
      this.showReactivateSubscription = true;
    },

    switchSubscriptionPlan() {
      this.showSwitchSubscriptionPlan = true;
    },

    hideSwitchSubscriptionPlan(plan) {
      this.showSwitchSubscriptionPlan = false;
      if (plan === null) {
        this.getSubscription();
      } else if (plan !== undefined) {
        this.changedPlan = plan;
      }
    },

    cancelSwitchSubscriptionPlan() {
      this.showCancelSwitchSubscriptionPlan = true;
    },

    hideCancelSwitchSubscriptionPlan(cancelled) {
      this.showCancelSwitchSubscriptionPlan = false;
      if (cancelled) {
        this.changedPlan = null;
      }
    },

    hideReactivateSubscription(reactivated) {
      this.showReactivateSubscription = false;
      if (reactivated) {
        this.cancelled = false;
        this.$emit("onSubscriptionLoad", {
          nextPayment: this.nextPayment,
          cancelled: this.cancelled,
        });
      }
    },

    hidePurchaseSeatsSuccessful() {
      this.showPurchaseSeatsSuccess = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* @media queries */
@mixin tablet {
  @media (max-width: 767px) and (min-width: 481px) {
    @content;
  }
}
@mixin mobile {
  @media (max-width: 480px) {
    @content;
  }
}
/* End of: @media queries */

.atto-btn {
  font: $roboto-bold 1rem/1.1875rem $roboto-font !important;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
}

.subscription {
  .centered-column {
    .content-section {
      .white-card {
        .current-plan,
        .switch-plan,
        .manage-seats {
          .pricing {
            width: 240px;
            justify-content: flex-end;
            @include mobile {
              justify-content: flex-start;
            }
          }
          .pricing,
          .btn-wrap {
            margin-left: 20px;
            @include mobile {
              margin-left: 0;
            }
          }
          .btn-wrap {
            @include tablet {
              margin-left: 0;
            }
            .switch {
              @include mobile {
                width: 100%;
              }
            }
          }
          @include tablet {
            .plan,
            p,
            .manage {
              @include mobile {
                width: 100%;
              }
            }
          }
          @include mobile {
            flex-direction: column;
            align-items: stretch;
            p {
              width: 100%;
              margin-bottom: 12px;
            }
          }
        }
      }
    }
  }
  .current-plan {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 40px;
    width: 100%;
    .plan-title {
      text-transform: capitalize;
    }
    .plan {
      h3 {
        font: $roboto-regular 1.25rem/1.75rem $roboto-font;
        color: $atto-font-color;
        margin-bottom: 12px;
      }
      p {
        color: $atto-font-color;
        font: $roboto-regular 0.9375rem/1.5rem $roboto-font;
        width: 100%;
      }
    }
    .pricing {
      display: flex;
      flex-direction: row;
      align-items: center;
      h3 {
        font: $roboto-regular 1.5rem/1.75rem $roboto-font;
        color: $atto-font-color;
        margin-right: 5px;
        @include tablet {
          font-size: 0.95rem;
          line-height: 0.95rem;
        }
      }
      span {
        display: inline-flex;
        font: $roboto-regular 1.125rem/1.75rem $roboto-font;
        color: $atto-font-color;
        @include tablet {
          font-size: 0.7rem;
          line-height: 0.7rem;
        }
      }
    }
  }

  // Switch Plan White Cards
  .switch-plan {
    display: flex;
    flex-direction: row;
    @include tablet {
      flex-direction: column;
    }
    @include mobile {
      flex-direction: column;
    }
    align-items: flex-start;
    justify-content: space-between;
    padding: 40px;
    p {
      color: $atto-font-color;
      font: $roboto-regular 0.9375rem/1.25rem $roboto-font;
      margin: 0;
      @include tablet {
        margin-bottom: 12px;
      }
      @include mobile {
        margin-bottom: 12px;
      }
    }
    button.switch {
      background-color: $atto-font-color;
    }
  }
  .btn-wrap {
    .save-label {
      font-family: "Roboto", sans-serif;
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-weight: 500;
      text-transform: uppercase;
      color: #cc63ad;
      margin: 8px auto 0;
    }
  }
  // End of: Switch Plan White Card

  // Manage Seats White Card
  .manage-seats {
    display: flex;
    flex-direction: row;
    @include tablet {
      flex-direction: column;
    }
    @include mobile {
      flex-direction: column;
    }
    align-items: flex-start;
    justify-content: space-between;
    padding: 40px;
    i {
      width: 24px;
      height: 24px;
      font-size: 13px;
      margin-right: 16px;
      margin-top: 4px;
      display: flex;
      align-items: center;
    }
    .manage {
      display: flex;
      flex-direction: column;
      h4 {
        font-size: 1.125rem;
        line-height: 2rem;
        font-weight: 500;
        color: #00b9cb;
        font-family: "Roboto", sans-serif;
        cursor: pointer;

        &:hover {
          color: #0a9ead;
        }
      }
      p {
        color: $atto-font-color;
        font: $roboto-regular 0.9375rem/1.25rem $roboto-font;
        margin: 0;
        @include tablet {
          margin-bottom: 12px;
        }
      }
    }
    .btn-wrap {
      justify-content: flex-start;
    }
  }
  // End of: Manage Seats White Card

  // Cancelled White Card
  div.cancelled {
    display: flex;
    flex-direction: row;
    @include tablet {
      flex-direction: column;
    }
    @include mobile {
      flex-direction: column;
    }
    align-items: flex-start;
    justify-content: space-between;
    text-align: left;
    padding: 40px;
    div {
      max-width: 580px;
      h3 {
        font-size: 1.25rem;
        line-height: 1.75rem;
        font-weight: normal;
        color: #e05656;
        margin-bottom: 8px;
        margin-top: 0;

        span {
          text-transform: capitalize;
        }
      }
      p {
        font: $roboto-regular 0.9375rem/1.5rem $roboto-font;
        margin-bottom: 0;
        color: #3c3d3e;
        @include tablet {
          margin-bottom: 12px;
        }
        @include mobile {
          margin-bottom: 12px;
        }
      }
    }
    hr {
      width: 50px;
      height: 2px;
      border-top: 0;
      background: #efefef;
      margin: 47px auto 43px;
    }
    p.reactivate {
      font-weight: 500;
      color: #00b9cb;
      margin-bottom: 38px;
    }
    .btn-wrap {
      margin-left: 20px;
      @include tablet {
        margin-left: 0;
      }
      @include mobile {
        margin-left: 0;
      }
      @include mobile {
        width: 100%;
      }
      button {
        width: 240px;

        @include mobile {
          width: 100%;
        }
        justify-content: center;
        font-weight: 500;
        text-transform: uppercase;
        font-size: 1rem;
        line-height: 1.5rem;
        margin: 0 auto;
        padding: 8px 12px;
      }
    }
  }
  // End of: Cancelled White Card
}
</style>
